import http, { url } from '../../http'

const API_URL = "measurement_medical_reports"

class evaluacionIdentificacionAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async saveF(resource) {
    const response = await http(`measurement_medical_config_data_sheet/save`, 'POST', resource)
    return response
  }

/*   async getAll(page) {
    const response = await http(`${API_URL}?page=${page}`)
    return response
  } 
 */

  async getAllF(id, page, search) {
    const response = await http(`measurement_medical_config_data_sheet/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 


  async getF(id) {
    const response = await http(`measurement_medical_config_data_sheet/index/${id}`, 'POST')
    return response
  }

  async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`)
    return response
  } 


  async get(id) {
    const response = await http(`${API_URL}/index/${id}`)
    return response
  }
  async getCode(resource) {
    const response = await http(`measurement_medical_reports/diagnostic_codes`, 'POST', resource)
    return response
  }

  async getExcel(companyId, Ayear) {
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.token) {
      return url(
        `${API_URL}/excelReport/${companyId}/${Ayear}?&access_token=${user.token}`
      );
    }

  }


  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }

  async getShowF(id) {
    const response = await http(`measurement_medical_config_data_sheet/show/${id}`)
    return response
  }

  async getMedicionAusentismoMensual(id, resource) {
    const response = await http(`${API_URL}/absenteeismMonthly/${id}`, 'POST',resource)
    return response
  }

  async getMonthlyTotals(id, resource) {
    const response = await http(`${API_URL}/reportAnual/${id}`, 'POST', resource)
    return response
  }

  async getMedicionAusentismoAnual(id, resource) {
    const response = await http(`${API_URL}/absenteeismAnnual/${id}`, 'POST', resource)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new evaluacionIdentificacionAPI()